import config from 'js/app/config';

export const CertificateType = {
  MasterTrackCertificate: 'MasterTrack® Certificate',
  ProfessionalCertificate: 'Professional Certificate',
  UniversityCertificate: 'Certificate',
  CertificadoMasterTrack: 'Certificado MasterTrack®',
};

export const CERTIFICATE_TYPE_TO_SLUG = {
  [CertificateType.MasterTrackCertificate]: 'mastertrack',
  [CertificateType.ProfessionalCertificate]: 'professional-certificates',
  [CertificateType.UniversityCertificate]: 'certificates/learn',
  [CertificateType.CertificadoMasterTrack]: 'mastertrack',
};

export const ENROLLMENT_FLOW = {
  paidOnCoursera: 'Paid for on Coursera',
  checklist: 'Checklist',
  externalLink: 'External Application Link',
  boomerang: 'Boomerang',
  noEnrollment: 'No Enrollment',
};

export const ARROW_LINE_DESKTOP = `${config.url.resource_assets}mtdp/Arrow-Line.png`;
export const ARROW_LINE_MOBILE = `${config.url.resource_assets}mtdp/Arrow-Line-Mobile.png`;
export const EARN_CREDIT_DECOR_IMAGE = `${config.url.resource_assets}mtdp/EarnCreditStudent.jpg`;

// Show only top three FAQs https://coursera.atlassian.net/browse/ACQU-1457
export const MAX_FAQS_TO_SHOW = 3;
